import css from "classnames";
import React from "react";
import { SportEvent as SoccerSportEvent } from "../../ScoreCenter/Soccer/SoccerLive/model";
import { SportEvent as TennisSportEvent } from "../../ScoreCenter/Tennis/TennisLive/model";

const styles = require("./styles.scss"); // tslint:disable-line no-var-requires

const enum Tabs {
    Match = "match",
    Stats = "stats",
    Timeline = "timeline"
}

interface State {
    languageCulture: string;
    activeTabId?: Tabs;
    shouldShowStats: boolean;
}

interface Props {
    component?: JSX.Element;
    sportEvent: SoccerSportEvent | TennisSportEvent; // to be refactored once we inherit model types
    lang: string;
}

export default class BetGeniusStats extends React.Component<Props, State> {
    private bgIframe: HTMLIFrameElement | null;

    constructor(props: Props) {
        super(props);

        const shouldShowStats = false;
        const languageCulture = "de-de";
        this.bgIframe = null;
        this.state = {
            activeTabId: Tabs.Match,
            languageCulture,
            shouldShowStats
        };

        this.getTabItem = this.getTabItem.bind(this);
    }

    public componentDidMount(): void {
        if (this.props.sportEvent.event.ended && this.bgIframe) {
            this.changeTab(Tabs.Timeline);
        }
    }

    public componentWillReceiveProps(nextProps: Props): void {
        if (nextProps.sportEvent.event.ended) {
            this.changeTab(Tabs.Timeline);
        }
    }

    public render(): JSX.Element {
        let isTimelineDisabled;
        const ended = this.props.sportEvent.event.ended;

        if (this.isFootball(this.props.sportEvent)) {
            const soccerSportEvent = this.props.sportEvent as SoccerSportEvent;
            isTimelineDisabled =
                !soccerSportEvent.event.eventPointList ||
                (soccerSportEvent.event.eventPointList &&
                    soccerSportEvent.event.eventPointList.length === 0);
        }

        const statsTabIfAvailable =
            !ended &&
            !isTimelineDisabled &&
            !this.state.shouldShowStats &&
            this.getTabItem(Tabs.Stats);
        const iframeWrapperCSS = css(
            styles.betgeniusIframeWrapper,
            this.state.activeTabId === Tabs.Timeline && this.props.component
                ? styles.hidden
                : null,
            !this.state.activeTabId ? styles.hidden : null
        );

        const timelineTabIfAvailable =
            this.state.activeTabId === Tabs.Timeline && this.props.component;

        return (
            <div>
                <div className={css(styles.betGeniusTabs)}>
                    {!ended && this.getTabItem(Tabs.Match)}
                    {statsTabIfAvailable}
                    {!isTimelineDisabled && this.getTabItem(Tabs.Timeline)}
                </div>

                <div className={iframeWrapperCSS}>
                    <iframe
                        scrolling="no"
                        ref={iframe => this.setIframe(iframe)}
                        id="betgenius-iframe"
                        className={css(styles.betgeniusIframe)}
                        src={this.getbetGeniusLink(this.props.sportEvent)}
                    />
                </div>
                {timelineTabIfAvailable}
            </div>
        );
    }

    private setIframe(iframe: HTMLIFrameElement | null) {
        this.bgIframe = iframe;
    }

    private isFootball(
        sportEvent: SoccerSportEvent | TennisSportEvent
    ): sportEvent is SoccerSportEvent {
        return sportEvent.sportId === "soccer";
    }

    private getbetGeniusLink(sportEvent: SoccerSportEvent | TennisSportEvent) {
        const bgSportId = this.isFootball(sportEvent) ? "football" : "tennis";

        const host = "tipico";

        // tslint:disable-next-line
        return `https://${host}.betstream.betgenius.com/betstream-view/page/tipico/${bgSportId}?culture=${this.state.languageCulture}&eventId=${this.props.sportEvent.betGeniusId}`;
    }

    private getTabItem(tabId: Tabs): JSX.Element {
        const sportId = this.props.sportEvent.sportId;
        const tabItemCSS = css(
            styles.tabItem,
            styles[sportId],
            styles[tabId],
            this.state.activeTabId === tabId ? styles.active : ""
        );
        return (
            <div
                className={tabItemCSS}
                onClick={this.changeTab.bind(this, tabId)}
            />
        );
    }

    private changeTab(id: Tabs): void {
        const sportEvent = this.props.sportEvent;

        const newState: Partial<State> = {
            activeTabId: id
        };

        if (this.bgIframe === null) {
            return;
        }

        switch (id) {
            case this.state.activeTabId: {
                newState.activeTabId = undefined; // close tabs
                break;
            }

            case Tabs.Match: {
                if (
                    this.isFootball(sportEvent) &&
                    !!this.bgIframe.contentWindow
                ) {
                    this.bgIframe.contentWindow.postMessage("showLive", "*");
                } else if (!!this.bgIframe.contentWindow) {
                    this.bgIframe.contentWindow.postMessage(
                        "showCourtView",
                        "*"
                    );
                }
                break;
            }

            case Tabs.Stats: {
                if (
                    this.isFootball(sportEvent) &&
                    !!this.bgIframe.contentWindow
                ) {
                    this.bgIframe.contentWindow.postMessage("showStats", "*");
                } else if (!!this.bgIframe.contentWindow) {
                    this.bgIframe.contentWindow.postMessage(
                        "showMatchStats",
                        "*"
                    );
                }
                break;
            }

            case Tabs.Timeline: {
                if (
                    !this.isFootball(sportEvent) &&
                    !!this.bgIframe.contentWindow
                ) {
                    // for soccer we are using our own timeline
                    this.bgIframe.contentWindow.postMessage(
                        "showSetStats",
                        "*"
                    );
                }
                break;
            }
        }

        this.setState(newState as State);
    }
}
